import React from "react"
import { reducer } from "./dataReducer"
import Values from "./ValuesComponent"
import { reactWidgetWrapper } from "live/widgets/decorators/react"
import widgetService from "live/services/widgets"

function ValuesWidget(
  props: LiveReactChartProps<
    ChartStateFlatGauge,
    ChartMessageFlatGauge,
    Configs
  >
): React.ReactElement {
  return Object.keys(props.state.value).length > 1 &&
    props.state.value.value ? (
    <Values
      height={props.height}
      width={props.width}
      value={props.state.value.value}
    />
  ) : null
}

widgetService.register({
  get type() {
    return "og_models_values"
  },
  get name() {
    return "OG Models Values"
  },
  get description() {
    return "It contains different layouts to be specified in order to display numerical values. It is commonly used on the OG Models dashboards"
  },
  config: {},
  policies: {
    defaultReducer: "@latest",
  },
  // the wrapper is needed to enable the reducer mechanism and comply the API
  impl: reactWidgetWrapper<ChartStateFlatGauge, ChartMessageFlatGauge, Configs>(
    ValuesWidget,
    reducer
  ),
})
